import React from 'react';
import { SubTitle, Description, Image } from '../../components/layouts';
import { Chart } from '../../components/Chart';
import { buildImageURL, getTrack } from '../../helpers';
import './style.scss';

const isWebp = document.querySelector('html').classList.contains('webpSupport');

const IMAGE = isWebp ? buildImageURL('/cpu-1.webp') : buildImageURL('/cpu-1.png');
const IMAGE_M = isWebp ? buildImageURL('/cpu-m-1.webp') : buildImageURL('/cpu-m-1.png');
const IMAGE21 = isWebp ? buildImageURL('/cpu-detail-1.webp') : buildImageURL('/cpu-detail-1.png');
const IMAGE22 = isWebp ? buildImageURL('/cpu-detail-2.webp') : buildImageURL('/cpu-detail-2.png');
const DIVIDER = isWebp ? buildImageURL('/cpu-detail-divider.webp') : buildImageURL('/cpu-detail-divider.jpg');

const track = getTrack({ block: 17 });
const track1 = getTrack({ block: 18 });
const track2 = getTrack({ block: 19 });

export function CPU1({mobile = false}) {
  return (
    <div className="page-section section-cpu-1 inverted">
      <div className="txt-wrapper" data-track={track}>
        <SubTitle >
          猛兽之速，淋漓尽畅
        </SubTitle>
        <Description>
          搭载高通骁龙 888 处理器，采用先进的 5nm 制程芯片，拥
          <br/>
          有超大核 Cortex-X1，体验疾速快感。
        </Description>
      </div>
      <Image className="img-wrapper" src={mobile ? IMAGE_M : IMAGE} />
      <div className="cup-detail-box" >
        <div className="cpu-detail-item" data-track={track1}>
          <SubTitle>12+3GB<br/>运存的快感</SubTitle>
          <Description>
            X60t Pro+ 在 12GB 运存<sup>4</sup>的基础上、利用内存融合技术<sup>5</sup>，可以调用 3GB 内存空间到运存进行使用，即刻享受 12+3GB 的运存快感。同时实现内核级重构，打造自然连贯的流畅动效。
          </Description>
          <Chart
            active={true}
            className="chart-1"
            title="重度应用场景下"
            prev={{
              value: 60,
              total: 100,
              valueLabel: '58%',
              title: <span>系统后台保活能力提升<sup>6</sup></span>
            }}
            next={{
              value: 100,
              total: 100,
              valueLabel: '37%',
              title: <span>运行使用效率提升<sup>6</sup></span>
            }}
            remark="注：对比不配备内存融合技术的机器"
          />
        </div>
        <div className="cpu-detail-item" data-track={track2}>
          <SubTitle>
            增强版UFS 3.1
            <br />
            大文件，秒读
          </SubTitle>
          <Description>UFS 3.1 让超高清电影、视频及超大文件都能够快速读取，轻松满足大家的快速存储需求。配合 UFS 深度碎片整理技术，大大降低存储碎片化导致的卡顿问题。</Description>
          <Chart
            active={true}
            className="chart-2"
            prev={{
              value: 16,
              total: 37,
              valueLabel: '14%',
              title: (
                <span>
                  随机写入速度提升<sup>7</sup>
                </span>
              )
            }}
          />
        </div>
      {/*  <Image src={IMAGE21} />*/}
      {/*  <Image src={IMAGE22} />*/}
      </div>
    </div>
  );
}
